import React from 'react';
import { FaStar } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import './TestimonialsSection.css';

const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      name: "James H.",
      role: "Plumbing Business Owner",
      quote: "BuildStart has been a game changer. We used to rely on word of mouth, but now 40% of our jobs come directly from the app. The verified badge definitely helps win trust.",
      avatar: "https://i.pravatar.cc/150?u=1"
    },
    {
      id: 2,
      name: "Sarah Jenkins",
      role: "Homeowner",
      quote: "I was terrified of hiring a 'cowboy' builder for my extension. Using BuildStart allowed me to check credentials instantly. Found a fantastic team in 24 hours.",
      avatar: "https://i.pravatar.cc/150?u=2"
    },
    {
      id: 3,
      name: "Michael Chen",
      role: "Property Developer",
      quote: "As a developer, I need reliability. I use the platform to source electricians and surveyors for multiple sites. It cuts my admin time in half.",
      avatar: "https://i.pravatar.cc/150?u=3"
    },
    {
      id: 4,
      name: "Emma W.",
      role: "Homeowner",
      quote: "Simple, fast, and transparent. I posted a job for a bathroom reno and got three quotes from verified pros within the same day. Highly recommended.",
      avatar: "https://i.pravatar.cc/150?u=4"
    },
    {
      id: 5,
      name: "David Ross",
      role: "Electrician",
      quote: "The lead quality is much higher here than on other directories. I'm not fighting with 20 other people for a tyre-kicker. The clients here are ready to hire.",
      avatar: "https://i.pravatar.cc/150?u=5"
    }
  ];

  return (
    <section className="bs-testimonials-section">
      <div className="bs-container">
        
        <div className="bs-testimonials-header">
           <div className="bs-header-stars">
              <FaStar /><FaStar /><FaStar /><FaStar /><FaStar /> 
              <span>4.9 Rated, 230+ Reviews</span>
           </div>
          <h2>HEAR WHAT THOUSANDS<br />OF OUR USERS THINK ABOUT US</h2>
          <p className="bs-testimonials-subtitle">
            Read about experiences of our users and see how we can connect you with the TOP Tradies in Town.
          </p>
        </div>

        {/* Horizontal Scroll Container */}
        <div className="bs-testimonials-scroller">
           {testimonials.map((t) => (
             <div key={t.id} className="bs-testimonial-card">
               <div className="bs-card-top">
                 <FcGoogle size={24} /> {/* Google Icon */}
                 <div className="bs-card-stars">
                    <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                 </div>
               </div>
               
               <p className="bs-quote">"{t.quote}"</p>
               
               <div className="bs-author">
                 <img src={t.avatar} alt={t.name} className="bs-avatar" />
                 <div className="bs-author-info">
                   <strong>{t.name}</strong>
                   <span>{t.role}</span>
                 </div>
               </div>
             </div>
           ))}
        </div>

        {/* Visual Dots to indicate scrolling */}
        <div className="bs-scroller-dots">
            <span></span><span className="active"></span><span></span>
        </div>

      </div>
    </section>
  );
};

export default TestimonialsSection;
